const clamp = (value, min, max) => Math.max(min, Math.min(max, value))

export const normalizePointerPosition = (
  clientX,
  clientY,
  viewportWidth,
  viewportHeight
) => {
  const safeWidth = viewportWidth || 1
  const safeHeight = viewportHeight || 1
  const normalizedX = (clientX / safeWidth) * 2 - 1
  const normalizedY = (clientY / safeHeight) * 2 - 1

  return {
    x: clamp(normalizedX, -1, 1),
    y: clamp(normalizedY, -1, 1),
  }
}

export const projectCubeVertices = (
  vertices,
  yawAngle,
  pitchAngle,
  cameraDistance,
  viewportWidth,
  viewportHeight,
  viewportRatio
) => {
  const cosY = Math.cos(yawAngle)
  const sinY = Math.sin(yawAngle)
  const cosX = Math.cos(pitchAngle)
  const sinX = Math.sin(pitchAngle)
  const centerX = viewportWidth / 2
  const centerY = viewportHeight / 2
  const focalLength =
    (Math.min(viewportWidth, viewportHeight) * cameraDistance * viewportRatio) / 2
  const bounds = {
    minX: Infinity,
    maxX: -Infinity,
    minY: Infinity,
    maxY: -Infinity,
  }

  const screenPoints = vertices.map(([x, y, z]) => {
    const rotatedX = x * cosY - z * sinY
    const rotatedZ = x * sinY + z * cosY
    const tiltedY = y * cosX - rotatedZ * sinX
    const tiltedZ = y * sinX + rotatedZ * cosX
    const depth = tiltedZ + cameraDistance
    const point = {
      x: centerX + (rotatedX * focalLength) / depth,
      y: centerY + (tiltedY * focalLength) / depth,
    }

    bounds.minX = Math.min(bounds.minX, point.x)
    bounds.maxX = Math.max(bounds.maxX, point.x)
    bounds.minY = Math.min(bounds.minY, point.y)
    bounds.maxY = Math.max(bounds.maxY, point.y)

    return point
  })

  return {
    screenPoints,
    bounds,
  }
}

export const createCornerPulse = (
  vertexCount,
  timeStamp,
  frequency,
  indexStep,
  phaseShift = 0,
  base = 0.14,
  amplitude = 0.52
) =>
  Array.from({ length: vertexCount }, (_, index) => {
    const wave = Math.sin(timeStamp * frequency + index * indexStep + phaseShift)
    const normalized = (wave + 1) / 2
    return base + normalized * amplitude
  })
